<nav
  class="navbar-v2 fixed-top"
  :class="{ 'navbar-v2--shrink': isShrunk, 'navbar-v2--club': isClubMode }"
>
  <div class="navbar-v2__bar">
    <router-link :to="brandHomeLink" class="navbar-v2__brand">
      <img :src="brandLogo" :srcset="brand.logoSrcset" sizes="80px" :alt="$t('navigation.logo')" />
      <span
        class="navbar-v2__brand-name"
        :style="brandNameStyle"
      >
        <span v-if="brandFull.left">{{ brandFull.left }}</span>
        <span v-if="brandFull.highlight" class="navbar-v2__brand-highlight">{{ brandFull.highlight }}</span>
        <span v-if="brandFull.right">{{ brandFull.right }}</span>
      </span>
    </router-link>

    <!-- <span v-if="!isClubMode" class="navbar-v2__brand-separator" aria-hidden="true"></span> -->

    <button
      type="button"
      class="navbar-v2__icon-btn navbar-v2__mobile-bell d-md-none"
      :aria-label="changelogHasUnread || profileRequestAttention ? $t('navigation.openNewChanges') : $t('navigation.openChangelog')"
      @click="openChangelogPanel"
    >
      <i class="bi bi-bell"></i>
      <span v-if="changelogHasUnread || profileRequestAttention" class="navbar-v2__dot" aria-hidden="true"></span>
    </button>

    <button
      class="navbar-v2__toggler d-md-none"
      ref="mobileMenuToggle"
      type="button"
      aria-controls="mobileNavigation"
      :aria-expanded="mobileMenuOpen"
      :aria-label="$t('navigation.toggleNavigation')"
      @click="openMobileMenu"
    >
      <i class="bi bi-list"></i>
    </button>

    <div class="collapse navbar-collapse navbar-v2__collapse" id="mainNavbar">
      <ul class="navbar-v2__links">
        <li v-if="isClubMode" class="navbar-v2__service-menu">
          <button
            class="navbar-v2__service-toggle dropdown-toggle"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i class="bi bi-globe2"></i>
            <span>{{ $t('navigation.service') }}</span>
          </button>
          <ul class="dropdown-menu">
            <li>
              <router-link class="dropdown-item" :to="buildLinkTo('Home')">
                <i class="bi bi-house me-2"></i> {{ $t('navigation.home') }}
              </router-link>
            </li>
            <li>
              <router-link class="dropdown-item" :to="buildLinkTo('AllClubs')">
                <i class="bi bi-buildings me-2"></i> {{ $t('navigation.clubs') }}
              </router-link>
            </li>
            <li>
              <details class="navbar-v2__chess-submenu">
                <summary class="dropdown-item" @click.stop><i class="bi bi-grid-3x3 me-2"></i>{{ $t('navigation.chess') }} <i class="bi bi-chevron-down ms-2"></i></summary>
                <router-link class="dropdown-item ps-4" :to="buildLinkTo('Chess')">{{ $t('navigation.chess960') }}</router-link>
              </details>
            </li>
            <li>
              <router-link class="dropdown-item" :to="buildLinkTo('Features')">
                <i class="bi bi-grid-3x3-gap me-2"></i> {{ $t('navigation.features') }}
              </router-link>
            </li>
            <li>
              <router-link class="dropdown-item" :to="buildLinkTo('About')">
                <i class="bi bi-info-circle me-2"></i> {{ $t('navigation.about') }}
              </router-link>
            </li>
            <li>
              <router-link class="dropdown-item" :to="buildLinkTo('Pricing')">
                <i class="bi bi-cash-coin me-2"></i> {{ $t('navigation.pricing') }}
              </router-link>
            </li>
          </ul>
        </li>
        <li v-if="isLoggedIn && !isOwnClub">
          <router-link class="navbar-v2__context-link" :to="buildLinkTo('ClubHome', { scope: 'user' })">
            {{ $t('navigation.myClub') }}
          </router-link>
        </li>
        <li v-if="isClubMode || (isLoggedIn && !isOwnClub)" class="navbar-v2__links-separator" aria-hidden="true"></li>
        <li v-if="isClubMode"><router-link :to="buildLinkTo('AllPlayers')">{{ $t('navigation.players') }}</router-link></li>
        <li v-if="isClubMode"><router-link :to="buildLinkTo('AllTournaments')">{{ $t('navigation.tournaments') }}</router-link></li>
        <li v-if="isClubMode"><router-link :to="buildLinkTo('AllSeasons')">{{ $t('navigation.seasons') }}</router-link></li>
        <li v-if="!isClubMode"><router-link :to="buildLinkTo('AllClubs')">{{ $t('navigation.clubs') }}</router-link></li>
        <li v-if="!isClubMode" class="dropdown">
          <button type="button" class="navbar-v2__chess-toggle dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">{{ $t('navigation.chess') }}</button>
          <ul class="dropdown-menu">
            <li><router-link class="dropdown-item" :to="buildLinkTo('Chess')">{{ $t('navigation.chess960') }}</router-link></li>
          </ul>
        </li>
        <li v-if="!isClubMode"><router-link :to="buildLinkTo('Features')">{{ $t('navigation.features') }}</router-link></li>
        <li v-if="!isClubMode"><router-link :to="buildLinkTo('About')">{{ $t('navigation.about') }}</router-link></li>
        <li v-if="!isClubMode"><router-link :to="buildLinkTo('Pricing')">{{ $t('navigation.pricing') }}</router-link></li>
      </ul>

      <div class="navbar-v2__actions">
        <button
          type="button"
          class="navbar-v2__icon-btn d-none d-md-grid"
          :aria-label="changelogHasUnread || profileRequestAttention ? $t('navigation.openNewChanges') : $t('navigation.openChangelog')"
          @click="openChangelogPanel"
        >
          <i class="bi bi-bell"></i>
          <span v-if="changelogHasUnread || profileRequestAttention" class="navbar-v2__dot" aria-hidden="true"></span>
        </button>

        <router-link
          :to="{ name: 'Home', hash: '#home-search' }"
          class="navbar-v2__icon-btn d-none d-md-grid"
          :aria-label="$t('navigation.search')"
        >
          <i class="bi bi-search"></i>
        </router-link>
        <button
          type="button"
          class="navbar-v2__icon-btn d-none d-md-grid"
          :aria-label="themeButtonLabel"
          @click="toggleTheme"
        >
          <i :class="themeIconClass"></i>
        </button>

        <LanguageSwitcher class="d-none d-md-block" />

        <span class="navbar-v2__actions-separator" aria-hidden="true"></span>

        <div v-if="canShowCreateMenu" class="dropdown navbar-v2__compact-menu">
          <button
            class="navbar-v2__create navbar-v2__create-compact dropdown-toggle"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i class="bi bi-plus-lg"></i>
            <span>{{ $t('navigation.create') }}</span>
          </button>
          <ul class="dropdown-menu dropdown-menu-end">
            <li>
              <router-link class="dropdown-item" :to="buildLinkTo('NewTournament')">
                <i class="bi bi-trophy me-2"></i> {{ $t('navigation.tournament') }}
              </router-link>
            </li>
            <li>
              <router-link class="dropdown-item" :to="buildLinkTo('NewSeason')">
                <i class="bi bi-calendar3 me-2"></i> {{ $t('navigation.season') }}
              </router-link>
            </li>
          </ul>
        </div>

        <div v-if="isLoggedIn" class="dropdown navbar-v2__compact-menu">
          <button
            class="navbar-v2__icon-btn navbar-v2__profile-btn"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            :aria-label="$t('navigation.openUserMenu', { name: currentUser?.username || '' })"
            :title="currentUser?.username || $t('navigation.profile')"
          >
            <i class="bi bi-person-circle"></i>
            <span class="d-md-none">{{ $t('navigation.profile') }}</span>
            <span class="dropdown-toggle d-md-none" aria-hidden="true"></span>
          </button>
          <ul class="dropdown-menu dropdown-menu-end">
            <li>
              <div class="navbar-v2__user-card">
                <strong>{{ currentUser?.username || $t('navigation.user') }}</strong>
                <span>{{ currentUser?.clubName || $t('navigation.clubNotSelected') }}</span>
              </div>
            </li>
            <li>
              <hr class="dropdown-divider">
            </li>
            <li>
              <router-link class="dropdown-item" :to="buildLinkTo('AdminToolMain', { scope: 'user' })">
                <i class="bi bi-speedometer2 me-2"></i> {{ $t('navigation.adminPanel') }}
              </router-link>
            </li>
            <li v-if="isSuperAdmin">
              <hr class="dropdown-divider">
            </li>
            <li v-if="isSuperAdmin" class="navbar-v2__data-source">
              <span class="navbar-v2__data-source-label">
                <i class="bi bi-database me-2"></i>
                {{ $t('navigation.dataSource', { source: dataSourceLabel }) }}
              </span>
              <div class="navbar-v2__data-source-switch" :aria-label="$t('navigation.dataSourceLabel')">
                <button
                  type="button"
                  :class="{ 'is-active': dataSource === 'db' }"
                  @click="setDataSource('db')"
                >
                  {{ $t('navigation.database') }}
                </button>
                <button
                  type="button"
                  :class="{ 'is-active': dataSource === 'mock' }"
                  @click="setDataSource('mock')"
                >
                  {{ $t('navigation.mockData') }}
                </button>
              </div>
            </li>
            <li>
              <a class="dropdown-item" href="#" @click.prevent="logout">
                <i class="bi bi-box-arrow-right me-2"></i> {{ $t('navigation.logOut') }}
              </a>
            </li>
          </ul>
        </div>

        <button
          v-else
          type="button"
          class="navbar-v2__icon-btn navbar-v2__auth-btn"
          :aria-label="$t('navigation.logIn')"
          :title="$t('navigation.logIn')"
          @click="openLoginModal"
        >
          <i class="bi bi-box-arrow-in-right"></i>
        </button>
      </div>
    </div>
  </div>

</nav>

<Teleport to="body">
  <div ref="mobileMenu" id="mobileNavigation" class="offcanvas offcanvas-start mobile-navigation" tabindex="-1" :aria-label="$t('navigation.toggleNavigation')">
    <header class="mobile-navigation__header">
      <router-link :to="mobileSection === 'service' ? buildLinkTo('Home') : brandHomeLink" class="mobile-navigation__brand" :class="{ 'mobile-navigation__brand--service': mobileSection === 'service' || !isClubMode }" @click="closeMobileMenu">
        <img :src="mobileBrand.logo" :srcset="mobileBrand.logoSrcset" sizes="80px" :alt="$t('navigation.logo')" />
        <span class="navbar-v2__brand-name" :style="mobileBrandNameStyle">
          <span v-if="mobileBrand.full.left">{{ mobileBrand.full.left }}</span>
          <span v-if="mobileBrand.full.highlight" class="navbar-v2__brand-highlight">{{ mobileBrand.full.highlight }}</span>
          <span v-if="mobileBrand.full.right">{{ mobileBrand.full.right }}</span>
        </span>
      </router-link>
      <button type="button" class="mobile-navigation__close" :aria-label="$t('common.close')" @click="closeMobileMenu"><i class="bi bi-x-lg" aria-hidden="true"></i></button>
    </header>
    <div ref="mobileMenuContent" class="mobile-navigation__content" :style="{ '--profile-offset': mobileProfileOffset + 'px' }">
    <div class="mobile-navigation__body" :inert="mobileSection === 'profile'">
      <nav class="mobile-navigation__links" :aria-label="$t('navigation.toggleNavigation')">
        <button v-if="isClubMode" type="button" class="mobile-navigation__service" :aria-expanded="mobileSection === 'service'" aria-controls="mobileNavigationLinks" @click="toggleMobileSection('service')">
          <i v-if="mobileSection === 'service'" class="bi bi-arrow-left" aria-hidden="true"></i>
          <i v-else class="bi bi-globe2" aria-hidden="true"></i>
          {{ $t('navigation.service') }}
          <i v-if="mobileSection !== 'service'" class="bi bi-chevron-right" aria-hidden="true"></i>
        </button>
        <div id="mobileNavigationLinks" class="mobile-navigation__primary">
          <template v-for="link in mobileLinks" :key="link.route">
            <details v-if="link.route === 'Chess'" class="mobile-navigation__chess">
              <summary><i class="bi" :class="link.icon" aria-hidden="true"></i>{{ link.label }}<i class="bi bi-chevron-down ms-auto" aria-hidden="true"></i></summary>
              <router-link :to="link.to" class="ps-4" @click="closeMobileMenu">{{ $t('navigation.chess960') }}</router-link>
            </details>
            <router-link v-else :to="link.to" @click="closeMobileMenu"><i v-if="link.icon" class="bi" :class="link.icon" aria-hidden="true"></i>{{ link.label }}</router-link>
          </template>
        </div>
      </nav>
      <div v-if="mobileSection !== 'service'" class="mobile-navigation__actions">
        <template v-if="isLoggedIn">
          <button ref="mobileProfileTrigger" type="button" class="mobile-navigation__account" :aria-expanded="mobileSection === 'profile'" aria-controls="mobileNavigationProfile" @click="toggleMobileSection('profile')">
            <i class="bi bi-person-circle" aria-hidden="true"></i>{{ $t('navigation.profile') }}<i class="bi" :class="mobileSection === 'profile' ? 'bi-chevron-up' : 'bi-chevron-down'" aria-hidden="true"></i>
          </button>
        </template>
        <button v-else type="button" class="mobile-navigation__account" @click="mobileLogin"><i class="bi bi-box-arrow-in-right" aria-hidden="true"></i>{{ $t('navigation.logIn') }}</button>
        <router-link v-if="isLoggedIn && !isOwnClub" class="mobile-navigation__my-club mobile-navigation__create" :to="buildLinkTo('ClubHome', { scope: 'user' })" @click="closeMobileMenu"><i class="bi bi-house-door" aria-hidden="true"></i>{{ $t('navigation.myClub') }}</router-link>
        <div v-if="canShowCreateMenu" class="mobile-navigation__create-wrap">
          <button type="button" class="app-button-primary mobile-navigation__create" :aria-expanded="mobileSection === 'create'" aria-controls="mobileNavigationCreate" @click="toggleMobileSection('create')"><i class="bi bi-plus-lg" aria-hidden="true"></i>{{ $t('navigation.create') }}<i class="bi" :class="mobileSection === 'create' ? 'bi-chevron-up' : 'bi-chevron-down'" aria-hidden="true"></i></button>
          <div v-if="mobileSection === 'create'" id="mobileNavigationCreate" class="mobile-navigation__submenu mobile-navigation__create-popup">
            <router-link :to="buildLinkTo('NewTournament')" @click="closeMobileMenu"><i class="bi bi-trophy me-2" aria-hidden="true"></i>{{ $t('navigation.tournament') }}</router-link>
            <router-link :to="buildLinkTo('NewSeason')" @click="closeMobileMenu"><i class="bi bi-calendar3 me-2" aria-hidden="true"></i>{{ $t('navigation.season') }}</router-link>
          </div>
        </div>
      </div>
    </div>
    <Transition name="mobile-profile" @after-enter="focusMobileProfile" @after-leave="focusMobileProfile">
      <section v-if="mobileSection === 'profile'" id="mobileNavigationProfile" class="mobile-navigation__profile">
        <button ref="mobileProfileBack" type="button" class="mobile-navigation__account" aria-expanded="true" aria-controls="mobileNavigationProfile" @click="toggleMobileSection('profile')">
          <i class="bi bi-person-circle" aria-hidden="true"></i>{{ $t('navigation.profile') }}<i class="bi bi-chevron-down" aria-hidden="true"></i>
        </button>
          <div class="mobile-navigation__submenu">
            <div class="mobile-navigation__user"><strong>{{ currentUser?.username || $t('navigation.user') }}</strong><small>{{ currentUser?.clubName || $t('navigation.clubNotSelected') }}</small></div>
            <router-link :to="buildLinkTo('AdminToolMain', { scope: 'user' })" @click="closeMobileMenu"><i class="bi bi-speedometer2 me-2" aria-hidden="true"></i>{{ $t('navigation.adminPanel') }}</router-link>
            <div v-if="isSuperAdmin" class="mobile-navigation__data-source">
              <small><i class="bi bi-database me-2" aria-hidden="true"></i>{{ $t('navigation.dataSourceLabel') }}</small>
              <TabToggle :model-value="dataSource" :options="[{ key: 'db', label: $t('navigation.database') }, { key: 'mock', label: $t('navigation.mockData') }]" :aria-label="$t('navigation.dataSourceLabel')" @update:model-value="setDataSource" />
            </div>
            <button type="button" @click="closeMobileMenu(); logout()"><i class="bi bi-box-arrow-right" aria-hidden="true"></i>{{ $t('navigation.logOut') }}</button>
          </div>
      </section>
    </Transition>
    </div>
  </div>
</Teleport>

<PublicSidePanel
  id="navbarNotificationsPanel"
  v-model="isNotificationsPanelOpen"
  :eyebrow="$t('navigation.notifications')"
  :title="$t('navigation.whatsNew')"
  @close="handleNotificationsHidden"
>
  <template #title-actions>
    <router-link :to="{ name: 'Changelog' }" class="app-link-button navbar-v2__all-notifications" @click="isNotificationsPanelOpen = false">
      {{ $t('notifications.all') }}
    </router-link>
  </template>
  <Notifications ref="notifications" @unread-change="setChangelogUnread" @open-history="isNotificationsPanelOpen = false" />
</PublicSidePanel>
